import React from 'react';

//styles
import { Table, Navbar } from 'react-bootstrap';

const Cart = ({item, clearCart, decreaseQuantity, deleteProduct,  increaseQuantity}) => {
  
    const getTotal = () => {
        return item.reduce((sum, {price, kiekis }) => sum + price*kiekis, 0).toFixed(2);
    }
    return (
        <div>
            <Navbar bg="secondary">
                <Navbar.Brand href="/">Jūsų prekių krepšelis</Navbar.Brand>
            </Navbar>
            <Table striped bordered hover variant="secondary">
                {item.length > 0 &&
                    <thead>
                    <tr>
                        <th>#</th>
                         <th>Nuotrauka</th>
                         <th>Prekės pavadinimas</th>
                         <th>Kiekis</th>
                         <th>Kaina</th>
                         <th>Trinti</th>
                    </tr>
                    </thead>
                }
                <tbody>
                { 
                    item && item.map((preke, index)=>(
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td><img src={preke.imageUrl} alt="prekes nuotrauka" style={{width: '150px'}}/></td>
                            <td>{preke.name}</td>
                            <td className="d-flex"><button className="btn btn-secondary mr-2" onClick={()=>decreaseQuantity(preke)}>-</button>  {preke.kiekis}  <button className="btn btn-secondary ml-2" onClick={()=>increaseQuantity(preke)}>+</button></td>
                            <td>{preke.price}</td>
                            <td><button className="btn btn-danger" onClick={()=>deleteProduct(preke)}>Naikinti</button></td>
                        </tr>  
                    ))
                }  
                 {item.length > 0 && 
                <tr>
                    <td colSpan="4">Bendra suma: {getTotal()} $</td>
                    <td><button className="btn btn-success" onClick={clearCart}>Eiti į apmokėjimą</button></td>
                    <td><button className="btn btn-danger" onClick={clearCart}>Išvalyti krepšelį</button></td>
                </tr>}
            </tbody>
            </Table>
        </div>
    )
}

export default Cart
